module.exports = {
    my_property:'My property',
    property_total:'Total asset conversion',
    capital_account:'capital account',
    withdraw:'withdrawal',
    withdraw1:'withdrawing',
    transfer:'transfer',
    trading_account:'fuel account',
    trading_account_card: 'fuel/point card account',
    top_up:'Recharge',
    // rebate_account:'Rebate bonus',
    rebate_account:'card',
    top_up_order:'Top up order',
    withdraw_order:'Withdrawal order',
    time:'time',
    type:'type',
    account:'account',
    kind:'currency',
    quantity:'quantity',
    address:'Address',
    schedule:'schedule',
    state:'state',
    top_up_success:'recharge successful',
    withdraw_success:'withdrawal successful',
    underway:'in progress',
    repeal_withdraw:'Cancel withdrawal',
    record:'record',
    record_time:'record time',
    account_type:'Bill Type',
    transaction:'transaction type',
    fee:'deduction',
    property_change:'Asset change',
    account_balance:'account balance',
    user_fee:'Fuel deduction',
    card_fee:'point card deduction',
    award_money:'amount',
    billing_profit:'Billing profit',
    change_address:'Change address/item',
    tip:'Only display the deposit/withdrawal order records within 7 days',
    my_capital:'My capital',
    capital_ratio:'capital ratio',
    invite_code:'invitation code',
    content: 'Content',
    combo: 'Combo',
    deduct: 'deduct',
    buy: 'Buy',
    waiting_for_payment: 'Waiting for payment',
    closed: 'Closed',
    operate:'operate',
    to_pay:'to pay',
    asset_recharge:'Asset recharge',
    mainnet:'Mainnet',
    wallet_address:'Wallet address (This address can only receive USDT)',
    important_note:'IMPORTANT NOTE:',
    min_deposit:'The minimum deposit amount is 50 USDT.',
    address_check:'Please double-check the address; if the address is incorrect, the refund will be impossible.',
    sure:'Sure',
    withdrawal_account:'The withdrawal account is a funds account.',
    withdrawal_fee:'The withdrawal fee is 5% of the withdrawal amount (minimum 5 USDT), which will be deducted directly from the withdrawal amount.',
    withdrawal_address:'Please ensure that you enter the correct withdrawal address and that the transfer network you select matches the address.',
    point_card_package:'Point card package',
    extra_gift:'Extra gift',
    selling_price:'selling price',
    billing_system:'The billing system will first deduct from the prepaid card account; if the prepaid card balance is insufficient, it will deduct from the fuel account.',
    card_not_withdraw:'The balance on the prepaid card cannot be withdrawn or transferred, and non-node users cannot gift it.',
    please_select_game_cards:'Please select the game cards you wish to purchase.',
    insufficient_funds:'Insufficient funds in your account. Please top up your account first!',
    purchase_successful:'Purchase successful'
}
